<main class="p-6 overflow-hidden pl-24 h-full max-h-full grid grid-rows-[36px_auto] gap-6">
    <div class="flex justify-between items-center">
        <h1 class="text-shs-white-1 text-3xl font-bold flex items-center gap-1 font-sh-bree">Dashboard</h1>
        <div class="flex gap-4">
            <sag-ui-button color="primary" size="sm" icon="plus-large" (click)="createNewCod()"
                >Create New COD</sag-ui-button
            >
        </div>
    </div>
    <div class="bg-[#1A1A1A] rounded-md p-6 overflow-hidden">
        <div class="flex items-center justify-between">
            <h2 class="text-base text-font-primary font-bold">COD Overview</h2>
            @if (!isBasicUser) {
            <div class="flex items-center gap-0 rounded-md">
                <div
                    [attr.data-selected]="selectedTab === 'my' ? 'true' : 'false'"
                    (click)="onTabChange('my')"
                    (keydown.enter)="onTabChange('my')"
                    tabindex="0"
                    class="text-sm text-shs-gray-1 font-semibold flex items-center gap-2 px-4 py-1 cursor-pointer border border-shs-gray-1 data-[selected=true]:border-font-primary data-[selected=true]:text-font-primary rounded-tl-md rounded-bl-md"
                >
                    <span class="icon-capacity"></span>
                    <span>My CODs</span>
                </div>
                <div
                    [attr.data-selected]="selectedTab === 'tasks' ? 'true' : 'false'"
                    (click)="onTabChange('tasks')"
                    (keydown.enter)="onTabChange('tasks')"
                    tabindex="0"
                    [class.rounded-tr-md]="!canViewAllCods"
                    [class.rounded-br-md]="!canViewAllCods"
                    class="text-sm text-shs-gray-1 font-semibold flex items-center gap-2 px-4 py-1 cursor-pointer border border-shs-gray-1 data-[selected=true]:border-font-primary data-[selected=true]:text-font-primary border-x-0"
                >
                    <span class="icon-capacity"></span>
                    <span>COD Tasks</span>
                </div>
                @if (canViewAllCods) {
                <div
                    [attr.data-selected]="selectedTab === 'all' ? 'true' : 'false'"
                    (click)="onTabChange('all')"
                    (keydown.enter)="onTabChange('all')"
                    tabindex="0"
                    class="text-sm text-shs-gray-1 font-semibold flex items-center gap-2 px-4 py-1 cursor-pointer border border-shs-gray-1 data-[selected=true]:border-font-primary data-[selected=true]:text-font-primary rounded-tr-md rounded-br-md"
                >
                    <span class="icon-browse-all"></span>
                    <span>All CODs</span>
                </div>
                }
            </div>
            }
        </div>
        <hr class="border-px border-[#333333] my-4" />
        <div class="flex items-center justify-between mb-4">
            <span class="text-xs text-[#B3B3B3]"
                >@switch (selectedTab) { @case ('my') { My CODs } @case ('tasks') { COD Tasks } @case ('all') { All CODs
                }}</span
            >
            <div class="relative">
                <input
                    [formControl]="searchControl"
                    placeholder="Search ..."
                    class="w-80 p-1 pl-7 border-b border-[#4D4D4D] bg-transparent text-sm text-font-primary focus:outline-none placeholder:text-font-secondary"
                />
                <span class="icon-search text-[#B3B3B3] absolute left-1 top-[6px]"></span>
            </div>
        </div>
        <div class="flex gap-4 my-4">
            @if (selectedTab !== 'my') {
            <app-table-user-filter
                label="Created by"
                [selected]="filters()['createdBy'] | asStringArray"
                (selectionChange)="setFilter('createdBy', $event)"
            ></app-table-user-filter>
            } @if (!isBasicUser && selectedTab !== 'tasks') {
            <app-table-user-filter
                label="Investigator"
                [selected]="filters()['assignedTo'] | asStringArray"
                (selectionChange)="setFilter('assignedTo', $event)"
            ></app-table-user-filter>
            }
            <app-table-filter
                [values]="natureOfComplaint"
                [selected]="filters()['natureOfComplaint'] | asStringArray"
                (selectionChange)="setFilter('natureOfComplaint', $event)"
                label="Nature of Complaint"
            ></app-table-filter>
            <app-table-filter
                [values]="region"
                [selected]="filters()['region'] | asStringArray"
                (selectionChange)="setFilter('region', $event)"
                label="Region"
            ></app-table-filter>
            <app-table-filter
                [values]="status"
                [selected]="filters()['status'] | asStringArray"
                (selectionChange)="setFilter('status', $event)"
                label="Status"
            ></app-table-filter>
            <app-table-country-filter
                [selected]="filters()['country'] | asStringArray"
                (selectionChange)="setFilter('country', $event)"
                label="Country"
            ></app-table-country-filter>
            <app-table-filter
                [values]="financialAdjustment"
                [selected]="filters()['financialAdjustment'] | asStringArray"
                (selectionChange)="setFilter('financialAdjustment', $event)"
                label="Financial Adjustment"
            ></app-table-filter>
        </div>
        @switch (selectedTab) { @case ('my') {
        <app-cod-overview-table
            [items]="(myCods$ | async) || []"
            [isLoading$]="isLoadingMyCods$"
            [isLazyLoading$]="isLazyLoadingMyCods$"
            [allLoaded$]="myCodsLoaded$"
            [showOptions]="isAdmin() ?? false"
            (rowClick)="handleRowClick($event)"
            (lazyLoad)="lazyLoadMyCods()"
            heading="My CODs"
            headerClasses="border-[#AB02ED] border-b-[#362f3a] from-[#AB02ED1A] to-[#6101871A]"
            borderClasses="border-[#AB02ED]"
        ></app-cod-overview-table>
        <div class="m-4"></div>
        } @case ('tasks') {
        <app-cod-overview-table
            [items]="(tasks$ | async) || []"
            [isLoading$]="isLoadingTasks$"
            [isLazyLoading$]="isLazyLoadingTasks$"
            [allLoaded$]="tasksLoaded$"
            [showOptions]="isAdmin() ?? false"
            (rowClick)="handleRowClick($event)"
            (lazyLoad)="lazyLoadTasks()"
            heading="COD Tasks"
            headerClasses="border-[#02D2ED] border-b-[#362f3a] from-[#02D2ED1A] to-[#0178871A]"
            borderClasses="border-[#02D2ED]"
        ></app-cod-overview-table>
        } @case ('all') {
        <app-cod-overview-table
            [items]="(allCods$ | async) || []"
            [isLoading$]="isLoadingAllCods$"
            [isLazyLoading$]="isLazyLoadingAllCods$"
            [allLoaded$]="allCodsLoaded$"
            [showOptions]="isAdmin() ?? false"
            (rowClick)="handleRowClick($event)"
            (lazyLoad)="lazyLoadAllCods()"
            heading="All CODs"
            headerClasses="border-[#02D2ED] border-b-[#362f3a] from-[#02D2ED1A] to-[#0178871A]"
            borderClasses="border-[#02D2ED]"
        ></app-cod-overview-table>
        } }
    </div>
</main>
